import {styled} from '@linaria/react';
import React, {ForwardedRef, forwardRef} from 'react';
import {FadePanel} from '../../atoms/FadePanel/FadePanel';

interface HorizontalListProps
  extends Omit<
    React.DetailedHTMLProps<
      React.HTMLAttributes<HTMLDivElement>,
      HTMLDivElement
    >,
    'ref'
  > {
  style?: React.CSSProperties;
  disableFade?: boolean;
}

export const HorizontalList = forwardRef<HTMLElement, HorizontalListProps>(
  function HorizontalList(
    {children, className, disableFade, ...props},
    forwardedRef,
  ) {
    return (
      <HorizontalListWrapper data-testid="horizontalList" className={className}>
        <HorizontalListSlider
          data-testid="list"
          ref={forwardedRef as ForwardedRef<HTMLDivElement>}
          position={'right'}
          size="2.5rem"
          disabled={disableFade}
          tabIndex={0}
          {...props}
        >
          {children}
        </HorizontalListSlider>
      </HorizontalListWrapper>
    );
  },
);

const HorizontalListWrapper = styled.div`
  position: relative;
  overflow: hidden;
  width: 100%;
  box-sizing: border-box;
`;

export const HorizontalListSlider = styled(FadePanel)`
  position: static;
  display: flex;
  flex-wrap: no-wrap;
  overflow-x: auto;
  -ms-overflow-style: none;
  scrollbar-width: none;
  &::-webkit-scrollbar {
    display: none;
  }
`;
